import React, { useState } from 'react'

import { Button } from 'semantic-ui-react'
import { AllowPermission } from 'shared/components/AllowPermission'
import { DescriptionPopupWithoutIcon } from 'components/DescriptionPopupWithoutIcon'
import UpgradePlanModalContainer from 'components/UpgradePlanModal/container'
import constants from 'config/constants'

const SIDE_POSITIONS = ['right center', 'left center']

/**
 *
 * @param {object} props
 * @param {string=} props.className
 * @param {string} [props.label]
 * @param {string | React.ReactElement} props.descriptionTitle
 * @param {string | React.ReactElement} props.descriptionContent
 * @param {string} props.learnMoreLink,
 * @param {boolean} [props.showGotoBillingPage]
 * @param {string} [props.position]
 * @param {function} [props.onPopupOpen]
 * @param {function} [props.onUpgradeClick]
 * @param { React.ReactElement | function} props.trigger
 */
const HOVER_AND_CLICK = ['hover', 'click']

export function TooltipLabelWithoutIcon({
  descriptionTitle,
  descriptionContent,
  learnMoreLink,
  showGotoBillingPage = false,
  position,
  onPopupOpen,
  onUpgradeClick,
  trigger,
  openOnClick = false,
}) {
  const [isPopupOpen, setIsPopupOpen] = useState(false)
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false)

  const style = {
    ...(showGotoBillingPage ? { minWidth: 380 } : {}),
    ...(SIDE_POSITIONS.includes(position) ? { marginTop: 0, marginBottom: 0 } : {}),
  }

  function openPopup() {
    setIsPopupOpen(true)
    if (onPopupOpen) {
      onPopupOpen()
    }
  }

  function openUpgradeModal() {
    setIsPopupOpen(false)
    setIsUpgradeModalOpen(true)
    if (onUpgradeClick) {
      onUpgradeClick()
    }
  }

  const triggerElement = typeof trigger === 'function' ? trigger({ openUpgradeModal }) : trigger

  if (descriptionTitle || descriptionContent) {
    return (
      <React.Fragment>
        <DescriptionPopupWithoutIcon
          className="grey"
          style={style}
          trigger={triggerElement}
          basic={true}
          open={isPopupOpen}
          on={openOnClick ? HOVER_AND_CLICK : undefined}
          onOpen={openPopup}
          onClose={() => setIsPopupOpen(false)}
          position={position}
        >
          {descriptionTitle && (
            <h3 className="ui dividing header" style={{ paddingBottom: '10px', paddingTop: '4px' }}>
              {descriptionTitle}
            </h3>
          )}
          <p>{descriptionContent}</p>
          {learnMoreLink && (
            <a
              className={`ui primary button ${showGotoBillingPage && 'mr3'}`}
              href={learnMoreLink}
              target="_blank"
              rel="noreferrer"
              onClick={preventEventPropagation}
            >
              <i className="book far icon" />
              Learn more
            </a>
          )}
          {showGotoBillingPage && (
            <AllowPermission permission={constants.permissions.manageBillingInformation}>
              <Button onClick={openUpgradeModal}>Upgrade plan</Button>
            </AllowPermission>
          )}
        </DescriptionPopupWithoutIcon>
        <UpgradePlanModalContainer
          isOpen={isUpgradeModalOpen}
          onClose={() => setIsUpgradeModalOpen(false)}
        />
      </React.Fragment>
    )
  }

  return <React.Fragment />
}

function preventEventPropagation(e) {
  e.stopPropagation()
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/TooltipLabelWithoutIcon/index.js